import React from "react";
import classNames from "classnames";
import "./BreabcrumbsItem.scss";

const BreabcrumbsItem = ({
  text,
  isFirst,
  isLast,
  onClick,
}) => {
  return (
    <div className="item">
      <span
        className={classNames({
          "item__text": true,
          "item__text--offset": !isFirst,
          "item__text--active": isLast,
        })}
        onClick={onClick}
      >
        {text}
      </span>

      {!isLast &&
        <span
          className={classNames({
            "item__text": true,
            "item__text_slash": true,
          })}
        >
          /
        </span>
      }
    </div>
  );
};

export default BreabcrumbsItem;
